import React from "react";
import useClickOutside from "../../services/click-outside";
import "./Dropdown.scss";

interface DropdownOption {
  id: string;
  label: string;
}

interface DropdownProps {
  id?: string;
  className?: string;
  fullWidth?: boolean;
  options: DropdownOption[];
  selectedOption: string;
  onSelect: (optionId: string) => void;
}

const Dropdown: React.FC<DropdownProps> = (props: DropdownProps) => {
  const { isVisible, toggleIsVisible, ref } = useClickOutside(false);

  const handleSelect = (optionId: string) => {
    props.onSelect && props.onSelect(optionId);
    toggleIsVisible();
  };

  return (
    <div
      className={`dropdown ${props.className || ""} ${props.fullWidth ? "flex-grow-1" : ""} ${isVisible ? "show" : ""}`}
      id={props.id}
      ref={ref}
    >
      <button
        className={`btn btn-light dropdown-toggle ${props.fullWidth ? "w-100" : ""}`}
        type="button"
        onClick={toggleIsVisible}
      >
        {
          props.options.find((option) => option.id === props.selectedOption)?.label
        }
      </button>
      <div
        className={`dropdown-menu text-center ${props.fullWidth ? "w-100" : ""} ${isVisible ? "show" : ""}`}
      >
        {props.options.map((option) => (
          <button
            key={option.id}
            className={`dropdown-item ${props.selectedOption === option.id ? "active" : ""}`}
            onClick={() => handleSelect(option.id)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Dropdown;
